import React from 'react'
import PulseLoader  from 'react-spinners/PulseLoader';


export default function PushEventModal({windowHeight, leftMargin, count,changesLeft, changesMax }) {

const override: CSSProperties = {
    display: "block",
    position: "absolute",
    top: "50%",
    left: "50%",
    margin: "0 auto",
    textAlign: "center",
    borderColor: "#982f2f",
    transform: "translate(-50%, -50%)",
  };
  
 let leftChange = changesMax-changesLeft

  return (
    <div className='overlay-modal' style={{position:'fixed',display:'flex',justifyContent:'center',top: windowHeight > 1000 ? '69px' : '0px',left:leftMargin,width:'100%',height:'94vh', backgroundColor:'rgba(0,0,0,0.5)',zIndex:100,overflowY:'auto'}}>
     
      <div className='overlap-content' style={{height:'500px',marginTop:'20%',padding:'20px',fontFamily:'lato',textAlign:'center',alignContent:'center',border:'none'}}>
           
          <h2>Rettelser er gemt i billetsystem </h2>
          <h3>Hjemmeside opdateres</h3><PulseLoader color="#982f2f" loading={true} height={100}  cssOverride={override}/>
           <br />
           <br />
          <div>
            <p style={{fontSize:'30px'}}>Overført {leftChange> 0 ? leftChange : 0} af {changesMax} rettelser til hjemmeside.</p>
          </div>                 
      </div>
  </div>
  )
}
